<div id="newPartnerContent" class="pages_tabs">
  <div id="newPartnerPagesContent" class="pages_content">
    <form class="create_partner_content" [formGroup]="partnerContentgrpForm">
      <!-- 1st column - Model SKU Info -->
      <div>
        <div id="column1ModalSkuInfo" class="form-group select-systemId">
          <label for="">
            <span i18n="@@new-partner-content.content.model-sku-info">Model SKU Info</span>
            <img class="round-info-icon" alt="info" [ngbPopover]="popContent" placement="top"
              triggers="mouseenter:mouseleave" />
            <ng-template #popContent>
              <div id="column1UploadPopover" class="popover-upload-req">
                <div id="column1NewPartnerContent" class="d-flex align-items-center">
                  <span i18n="@@new-partner-content.content.systemid-determine">The System ID determines which of your devices this content will appear on.</span>
                </div>
              </div>
            </ng-template>
          </label>
          <div id="editButton" *ngIf="isEdit" class="btn-group d-block" container="body">
            <button [disabled]='isEdit' container="body" type="button" class="sku-select btn btn-primary">
              {{valueModelSKUInfo.length > 20 ? (valueModelSKUInfo | slice:0:20) + '...' : valueModelSKUInfo }}
            </button>
          </div>
          <ng-select *ngIf="!isEdit" [items]="modelSkuList"
              [ngbTooltip]="selectedSystemId ? selectedSystemId?.length > 20 ? selectedSystemId:'':''" bindLabel="systemID"
              bindValue="autoID" [clearable]="true" placeholder="{{ systemIdSearch }}" [selectOnTab]="true"
              (change)="selectSystemID($event)" [(ngModel)]="valueModelSKUInfo" [ngModelOptions]="{standalone: true}">
            </ng-select>
        </div>
        <div id="modelSkuHintText" class="hint_text">
          <span i18n="@@new-partner-content.content.link">If you cannot find Model SKU Info for your device, you may
            enter it <a class="btn-link link-pointer" (click)="goToCreateNewModelSku()">here</a>.</span>
        </div>
        <div id="column1displayContent" class="form-group" *ngIf="isSystemIdSelected">
          <label for=""><span i18n="@@new-partner-content.content.displayname">English Display Name</span>
            <img class="round-info-icon" alt="info" placement="right" popoverTitle="{{popDisplay}}"
              [ngbPopover]="englishpop" container="body" alt="" triggers="mouseenter:mouseleave" />
            <ng-template #englishpop><span i18n="@@new-partner-content.content.displayname-explain">
                <div>Appears on IPOS if a display name is not
                  <div>available for the locale of the device</div>
                </div>
              </span>
            </ng-template>
          </label>
          <div class="model-break" id="">{{englishDisplayName}}</div>
        </div>
        <div id="column1SystemModel" class="form-group" *ngIf="isSystemIdSelected">
          <label for=""><span i18n="@@new-partner-content.content.system-models">System Models</span></label>
          <div class="model-break" id="displaySystemModel">
            <ng-container>
              <span>{{displaySytemModel}}</span>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="inline_separator"></div>
      <!-- 2nd Column - Content Info -->
      <div>
        <div id="column2ContentName" class="form-group">
          <label for="contentName">
            <span i18n="@@new-partner-content.content.content-name">Content Name</span>&nbsp;<span
              class="coral">*</span>
          </label>
          <input #contentNameInput [ngClass]="{'err_border' : isContentNameNotUnique}" type="text" class="form-control"
            id="contentName" [placeholder]="enterContentNamePlaceHolder" formControlName="contentName" maxlength="50"
            required (input)="contentNameChange()" />
          <em *ngIf="isContentNameNotUnique" class="err_icon_highlight"></em>
          <div id="contentNameNotUnique" *ngIf="isContentNameNotUnique" class="formfield_err_msg err_margin"><span
              i18n="@@new-partner-content.content.content-name-already">Content name already exists</span></div>
        </div>
        <div id="column2TileThumbnail" class="form-group">
          <label for="tileThumbnail"><span i18n="@@new-partner-content.content.tile-thumbnail">Tile
              Thumbnail</span>&nbsp;<span class="coral">*</span>
            <img class="round-info-icon" alt="info" [ngbPopover]="popContentThumbnail" placement="top"
              triggers="mouseenter:mouseleave" />
            <ng-template #popContentThumbnail>
              <div id="column2UploadPopover" class="popover-upload-req">
                <div id="column2PopoverContent" class="d-flex align-items-center">
                  <span i18n="@@new-partner-content.content.tile-thumbnail-popup">Thumbnail must be in PNG, JPG, or <div>
                      GIF format.</div></span>
                </div>
              </div>
            </ng-template>
          </label>
          <button type="button" class="btn btn-primary left_icon_btn" data-toggle="modal"
            data-target="#tileThumbnailPopup" [disabled]="!isSystemIdSelected" (click)="selectThumbnailPopup()">
            <img class="image_icon" alt="Add Tile Image" /><span
              i18n="@@new-partner-content.content.add-tile-button">Add Tile Image</span>
          </button>
          <div id="thumbnailNameWrapper" class="name-wrapper">
            <span class="uploaded_file_name">{{thumbnailName}}</span>
          </div>
        </div>
        <div id="hColor" class="form-group color-container BGColumn mt-3">
          <label for="" i18n="@@page.content.bg-color">Background color</label>
          <input readonly [(colorPicker)]="bgColor" [cpPosition]="'right'" [style.background]="bgColor" class="color_picker_button" (colorPickerChange)="emitPageDataToPreview()" role="button">
        </div>
        <div id="column2TileCta" class="form-group">
          <label for="tileCTA"><span i18n="@@new-partner-content.content.tile-cta">Tile CTA</span>&nbsp;<span
              class="coral">*</span>
          </label>
          <input type="text" class="form-control" id="tileCTA" [placeholder]="tileCtaPlaceHolder" maxlength="50"
            formControlName="tileCTA" required />
        </div>
      </div>
      <div class="inline_separator"></div>
      <!-- 3rd Column - Language Info -->
      <div>
        <div id="column3LanguageCategory" class="form-group">
          <label for="languageCategory"><span i18n="@@new-partner-content.lang-category">Language
              Category</span>&nbsp;<span class="coral">*</span>
            <img class="round-info-icon" alt="info" [ngbPopover]="popContentLangCategory" placement="top"
              triggers="mouseenter:mouseleave" />
            <ng-template #popContentLangCategory>
              <div id="column3UploadPopover" class="popover-upload-req">
                <div id="column3PopoverContent" class="d-flex align-items-center">
                  <span i18n="@@new-partner-content.lang-category-explain">Use this to distinguish between <div>language
                      groupings of a platform.</div></span>
                </div>
              </div>
            </ng-template>
          </label>
          <input type="text" class="form-control" id="languageCategory" [placeholder]="langCatPlaceHolder"
            maxlength="50" formControlName="languageCategory" required />
        </div>
        <div id="column3TileThumbnail" class="form-group">
          <label for="tileThumbnail"><span i18n="@@new-partner-content.lang">Languages</span>&nbsp;<span
              class="coral">*</span>
            <img class="round-info-icon" alt="info" [ngbPopover]="popContentSelectLang" placement="top"
              triggers="mouseenter:mouseleave" />
            <ng-template #popContentSelectLang>
              <div id="column3UploadPopover" class="popover-upload-req">
                <div id="column3PopoverContent" class="d-flex align-items-center">
                  <span i18n="@@new-partner-content.lang-explain">Select the language or language <div>versions of IPOS
                      you would like <div>associated with
                        this content.</div>
                    </div></span>
                </div>
              </div>
            </ng-template>
          </label>
          <button type="button" class="btn btn-primary left_icon_btn" [disabled]="!isSystemIdSelected"
            (click)="openMultiSelectLanguageModal()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
              class="select-language-svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10ZM9.375 1.34625C8.5375 1.60125 7.70625 2.37125 7.01625 3.665C6.8375 4 6.67125 4.365 6.5225 4.755C7.40375 4.95125 8.3625 5.07625 9.375 5.11375V1.34625ZM5.31125 4.42375C4.79703 4.25853 4.29636 4.05375 3.81375 3.81125C4.62804 2.99714 5.59479 2.35151 6.65875 1.91125C6.3783 2.27834 6.12869 2.668 5.9125 3.07625C5.68271 3.51198 5.48226 3.96256 5.3125 4.425L5.31125 4.42375ZM4.38625 9.375H1.27125C1.38764 7.71221 1.97898 6.1178 2.975 4.78125C3.5625 5.10375 4.21875 5.38375 4.93125 5.615C4.60715 6.84356 4.42388 8.10501 4.385 9.375H4.38625ZM6.13625 5.94875C7.14625 6.1825 8.2375 6.325 9.375 6.36375V9.375H5.6375C5.68125 8.14125 5.8575 6.9825 6.13625 5.94875ZM10.625 6.3625V9.375H14.3625C14.3253 8.21782 14.158 7.0685 13.8637 5.94875C12.8537 6.1825 11.7625 6.325 10.625 6.36375V6.3625ZM5.6375 10.625H9.375V13.6363C8.2375 13.6738 7.14625 13.8175 6.13625 14.0513C5.84155 12.9315 5.67383 11.7822 5.63625 10.625H5.6375ZM10.625 10.625V13.6363C11.7625 13.6738 12.8537 13.8175 13.8637 14.0513C14.1425 13.0175 14.3188 11.8588 14.3638 10.625H10.625ZM6.5225 15.245C7.46048 15.0393 8.41527 14.9197 9.375 14.8875V18.655C8.5375 18.4 7.70625 17.63 7.01625 16.3363C6.82944 15.9834 6.66454 15.6194 6.5225 15.2462V15.245ZM6.66 18.09C6.37904 17.7226 6.12901 17.3325 5.9125 16.9237C5.68228 16.4881 5.48141 16.0375 5.31125 15.575C4.79704 15.7403 4.29638 15.945 3.81375 16.1875C4.62781 17.0025 5.59458 17.649 6.65875 18.09H6.66ZM4.93125 14.385C4.25452 14.6011 3.59956 14.8802 2.975 15.2188C1.97937 13.8821 1.38846 12.2877 1.2725 10.625H4.385C4.42345 11.895 4.60672 13.1565 4.93125 14.385ZM13.3413 18.09C14.4049 17.6493 15.3712 17.0032 16.185 16.1888C15.7028 15.9463 15.2025 15.7415 14.6888 15.5763C14.5185 16.0383 14.3177 16.4885 14.0875 16.9237C13.8714 17.3325 13.6218 17.7226 13.3413 18.09ZM10.625 14.8863C11.6375 14.9238 12.5962 15.0487 13.4775 15.245C13.3275 15.635 13.1625 16 12.9838 16.335C12.2937 17.6287 11.4613 18.3975 10.625 18.6538V14.8875V14.8863ZM15.0688 14.385C15.7812 14.6163 16.4375 14.8963 17.025 15.2188C18.0206 13.8821 18.6115 12.2877 18.7275 10.625H15.615C15.5765 11.895 15.3933 13.1565 15.0688 14.385ZM18.7275 9.375H15.615C15.5765 8.10497 15.3933 6.84347 15.0688 5.615C15.7454 5.39862 16.4003 5.11949 17.025 4.78125C18.0206 6.11791 18.6115 7.71233 18.7275 9.375ZM14.0875 3.07625C14.3088 3.49375 14.5112 3.94375 14.69 4.42375C15.2034 4.25843 15.7032 4.05365 16.185 3.81125C15.3711 2.99728 14.4048 2.35165 13.3413 1.91125C13.6138 2.265 13.8638 2.6575 14.0875 3.07625ZM13.4775 4.755C12.5962 4.95125 11.6362 5.07625 10.625 5.11375V1.34625C11.4625 1.60125 12.2937 2.37125 12.9838 3.665C13.1625 4 13.3287 4.365 13.4775 4.755Z" />
            </svg><span i18n="@@new-partner-content.select-lang-button">Select Languages</span>
          </button>
      
            <iposcen-lang-multi-select *ngIf='isSystemIdSelected' #profileLanguageModal [selectedLang]='lanuageEdit'
              [isInEdit]='isEdit' [isDuplicate]='duplicacy' (updateLanguage)="updateLanguageDetails($event)"
              [isPopupOpenAuto]='popUpOpen' [selectedItem]="selectedLangauge"
              [isPartnerContent]='isPartnerContentLanguage' [systemIdSelectedLang]='sytsemIdSelectedLanguage'>
            </iposcen-lang-multi-select>
            <div id="selectedLanguageName" class="selected_langs">{{selectedLangaugeName}}</div>
        </div>
      </div>
    </form>
    <!-- Language validation popUp  -->
    <div id="languageValidationPopup" *ngIf="isAllLanguagesSelected">
      <div id="languageValidationModalDialog" class="modal-dialog modal-dialog-centered">
        <div id="lvModalDocument" class="modal-dialog modal-dialog-centered" role="document">
          <div id="lvModalBackdrop" class="modal-backdrop show"></div>
          <div class="modal" id="tileThumbnailPopup">
            <div id="lvModalDialog" class="modal-dialog">
              <div id="lvModalContent" class="modal-content language_style">
                <div id="lvPopupClose" class="close" data-dismiss="modal" (click)="closePopup()">
                  <img class="modal-close-icon" alt="close" />
                </div>
                <div id="languageValidationModalBody" class="modal-body pb-0">
                  <div id="lvModalText" class="d-flex align-items-center mb-4">
                    The chosen Model SKU has already been associated with all languages. Edit the existing content
                    groups associated to the chosen Model SKU
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="newPartnerBtnWrapper" class="button_wrapper">
    <button type="button" class="btn btn-outline-primary" (click)="goBack()"><span
        i18n="@@new-partner-content.cancel-button">Cancel</span>
    </button>
    <button type="button" class="btn btn-primary" (click)="onAdd()" [disabled]="!partnerContentgrpForm?.controls?.contentName?.value || !partnerContentgrpForm?.controls?.tileCTA?.value
    || !partnerContentgrpForm?.controls?.languageCategory?.value || !isThumbnailSelected || isLanguageEmpty"><span
        i18n="@@new-partner-content.save-button">Save and Proceed</span>
    </button>
  </div>
</div>



<!-- Tile Thumbnail popup -->
<div id="selectTileThumbnailPopup" *ngIf="selectTileThumbnailPopup">
  <div id="tileThumbnailModalBackdrop" class="modal-backdrop show"></div>
  <div class="modal" id="tileThumbnailPopup" role="dialog">
    <div id="tileThumbnailModalDialog" class="modal-dialog modal-dialog-centered" role="document">
      <div id="tileThumbnailModalContent" class="modal-content thumbnail_style">
        <div id="selectThumbnailModalCloseIcon" class="close" data-dismiss="modal" (click)="closeSelectThumbnailPopup()">
          <img src="../../../../assets/images/modal_close_icon.svg" alt="close" />
        </div>
        <div id="selectThumbnailModalBody" class="modal-body pb-0">
          <div id="thumbnailModalHeading" class="d-flex align-items-center mb-4">
            <h2 class="heading" placement="bottom" [ngbTooltip]="selectedSystemId.length > 20 ? selectedSystemId : ''">
              {{selectedSystemId.length > 20? (selectedSystemId | slice:0:20) + '...' : selectedSystemId}}</h2>
            <span i18n="@@new-partner-content.tile-thumbnail-popup">Tile Thumbnails</span>
          </div>
          <ng-container *ngIf="!isTileDataEmpty">
            <iposcen-spinner-overlay></iposcen-spinner-overlay>
          </ng-container>
          <div id="selectThumbnailImageWrapper" class="row img-wrapper">
            <div id="temptyTileData" class="text-center" *ngIf="isTileDataEmpty"><span
                i18n="@@new-partner-content.thumbnail.no-assets-desc">No assets found. Please add assets by uploading
                them from <a class="here-link" (click)="redirectToModelSku()">here</a>.</span></div>
            <div id="thumbnailData" class="col-3" *ngFor="let thumbnail of tileThumbnail">
              <div id="thumbnailImageCard" class="card card-view" [ngClass]="thumbnail.selectedThumbnail?'active':''">
                <img class="card-img-top" [src]="thumbnail.imageData" alt="thumbnail"
                  (click)="selectedThumbnail(thumbnail.assetID, thumbnail)" />
                <div id="thumbnailCardFooter" class="card-footer">{{thumbnail.assetName}}</div>
              </div>
            </div>

          </div>
        </div>

        <div id="tileThumbnailModalFooter" class="modal-footer" *ngIf="tileThumbnail?.length">
          <button type="button" class="btn btn-outline-primary" data-dismiss="modal"
            (click)="closeSelectThumbnailPopup()">
            <span i18n="@@new-partner-content.cancel-button">Cancel</span>
          </button>
          <button [disabled]="disableImage" type="button" class="btn btn-primary gtmUsersAddDomains"
            (click)="finalThumbnailSelected(thumbnail)">
            <span i18n="@@new-partner-content.select-thumbnail-button">Select Thumbnail</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>